import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const PageCTA = ({ label }) => (
  <section className="relative z-10 py-20 md:py-28 bg-[#050505] border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 text-center">
      <Link
        to="/#contact"
        data-testid="page-cta"
        className="group inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-black font-semibold px-10 py-4 hover:bg-[#F2E3C6] transition-colors duration-300"
      >
        {label}
        <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
      </Link>
    </div>
  </section>
);
